import { Modal, useTheme } from '@mui/material'

import {
  Action,
  PasswordSettingsTemplate,
} from '@/components/pages/PasswordSettings/template'

type WalletPasswordSettingModalProps = {
  open: boolean
  onClose: () => void
  onSubmit: Action['onSubmitWalletPassword']
  email?: string | null
}
/**
 * @description
 * 仮想通貨ウォレット連携前提の、Utoniq側のauthへのメアド・パスワード認証登録フォーム用モーダル
 */
export const WalletPasswordSettingModal = ({
  open,
  onClose,
  onSubmit,
  email = '',
}: WalletPasswordSettingModalProps) => {
  const { zIndex } = useTheme()

  return (
    <Modal open={open} sx={{ zIndex: zIndex.modal + 3 }}>
      <PasswordSettingsTemplate
        state={{ hasPassword: false, forWallet: true, email }}
        onSubmit={async () => {}}
        onSubmitUnregisteredPassword={async () => {}}
        onSubmitWalletPassword={onSubmit}
        onClose={onClose}
      />
    </Modal>
  )
}
